import { Link } from "react-router-dom";
import { trackNewsletterSignup } from "../lib/analytics";
import React, { useState } from "react";
import { supabase } from "../lib/supabase";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
     const { error: err } = await supabase
        .from("newsletter")
        .insert({ email });
      if (err) throw err;
      
      // Notifica via email
      await supabase.functions.invoke("newsletter-notify", {
        body: { email },
      });
      
      trackNewsletterSignup();
  setSuccess(true);
    } catch (err) {
      if (err.message?.includes("duplicate")) {
        setError("Questa email è già iscritta alla newsletter!");
      } else {
        setError("Qualcosa è andato storto. Riprova!");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-16 relative">
      <div className="absolute inset-0 grid-pattern opacity-30" />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-10">
          <div className="text-overline text-yellow-400 mb-3">// Resta aggiornato</div>
          <h1 className="font-display font-black text-4xl uppercase tracking-tight">Newsletter</h1>
          <p className="text-zinc-400 mt-4">Iscriviti per ricevere le ultime notizie sull'ASD Rubiana Calcio.</p>
        </div>
        {success ? (
          <div className="rounded-2xl bg-zinc-900 border border-zinc-800 p-8 text-center">
            <div className="text-yellow-400 text-4xl mb-4">✓</div>
            <h2 className="font-display font-bold text-xl uppercase mb-2">Iscritto!</h2>
            <p className="text-zinc-400">Grazie per esserti iscritto alla nostra newsletter.</p>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="rounded-2xl bg-zinc-900 border border-zinc-800 p-8 space-y-5">
            {error && (
              <div className="rounded-lg bg-red-500/10 border border-red-500/40 px-4 py-3 text-sm text-red-300">
                {error}
              </div>
            )}
            <div>
              <label className="text-zinc-300 text-sm font-medium block mb-1.5">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 rounded-lg bg-zinc-950 border border-zinc-800 text-zinc-100 focus:outline-none focus:border-yellow-400"
                placeholder="la-tua@email.it"
              />
            </div>
            <div className="flex items-start gap-3">
  <input
    type="checkbox"
    id="privacy"
    required
    className="mt-1 h-4 w-4 rounded border-zinc-700 bg-zinc-950 text-yellow-400"
  />
  <label htmlFor="privacy" className="text-sm text-zinc-400">
    Ho letto e accetto l'<Link to="/privacy" className="text-yellow-400 hover:underline">informativa sulla privacy</Link>
  </label>
</div>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2 px-4 rounded-full bg-yellow-400 text-zinc-950 font-display font-bold hover:bg-yellow-300 transition-colors"
            >
              {loading ? "Iscrizione…" : "Iscriviti"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
